import React from "react";

function ApplicationConfirmationModal({ job, onConfirm, onCancel }) {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
      onClick={onCancel}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "2rem",
          maxWidth: "500px",
          width: "90%",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2
          style={{
            color: "#2c3e50",
            fontSize: "1.5rem",
            fontWeight: "600",
            marginBottom: "1rem",
          }}
        >
          Did you apply for this job?
        </h2>
        <div
          style={{
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            padding: "1rem",
            marginBottom: "1.5rem",
          }}
        >
          <h3
            style={{
              color: "#2c3e50",
              fontSize: "1.1rem",
              fontWeight: "600",
              margin: "0 0 0.5rem 0",
            }}
          >
            {job?.title}
          </h3>
          <p
            style={{
              color: "#007bff",
              fontWeight: "500",
              margin: "0 0 0.5rem 0",
            }}
          >
            {job?.company}
          </p>
          <p
            style={{
              color: "#6c757d",
              fontSize: "0.9rem",
              margin: 0,
            }}
          >
            {job?.location}
          </p>
        </div>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            justifyContent: "flex-end",
          }}
        >
          <button
            onClick={onCancel}
            style={{
              padding: "0.75rem 1.5rem",
              backgroundColor: "#6c757d",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "500",
              fontSize: "0.9rem",
            }}
          >
            No, Not Yet
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: "0.75rem 1.5rem",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "500",
              fontSize: "0.9rem",
            }}
          >
            Yes, I Applied
          </button>
        </div>
      </div>
    </div>
  );
}

export default ApplicationConfirmationModal;

